<template>
  <div>
    <div class="modal-header">
      <h2>Dodaj isplatu</h2>
    </div>
    <div class="body transactoin-income-body">
      <div class="input-wrapper">
        <div class="name--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--name"
            placeholder=" "
            v-model="payoutName"
          />
          <span class="input-span input-span--name">Naziv</span>
        </div>
        <div class="amount--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--amount"
            placeholder=" "
            v-model.lazy="payoutAmount"
            v-money="{}"
          />
          <span class="input-span input-span--amount">Iznos</span>
        </div>
      </div>
      <div>
        <label for="issue-date" class="desc">Datum izdavanja</label>
        <datetime
          ref="datetime"
          type="date"
          @input="handleDatetimeInput"
          :phrases="{
                  ok: 'U redu',
                  cancel: 'Otkaži'
                }"
          format="dd/MM/yyyy"
          v-model="issueDate"
        ></datetime>
        <div
          class="form-control form-control-lg datetime-mask"
          type="text"
          id="issue-date"
          @click="handleDatetimeClick"
        >
          {{ issueDate | formatDate }}
          <i class="far fa-calendar-alt calendar--mod"></i>
        </div>
      </div>
    </div>
    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>
      <div class="buttons">
        <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
        <button type="submit" class="btn btn-primary btn--mod" @click="save" :disabled="loading">
          <p v-if="!loading">Sačuvaj</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import { Datetime } from 'vue-datetime';
import { formatDateMixin } from '@/mixins/mixins.js';

export default {
  components: {
    Datetime
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      payoutName: '',
      payoutAmount: '',
      loading: false,
      issueDate: ''
    };
  },
  computed: {
    ...mapState('finances', ['transactions'])
  },
  mixins: [formatDateMixin],
  created() {
    document.addEventListener('keydown', this.processKeyboardEvent);
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('finances', ['getTableData', 'getAccountDetails']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    handleDatetimeInput(value) {
      if (value == '') {
        this.issueDate = new Date().toISOString();
      } else {
        this.issueDate = value;
      }
    },
    handleDatetimeClick() {
      this.$refs.datetime.$el.querySelector('.vdatetime-input').focus();
    },
    getTodayDateFormatted() {
      let todayDate = new Date().toISOString();
      let dateYear = todayDate.split('T')[0];
      let dateHour = todayDate.split('T')[1].split('.')[0];
      return dateYear + ' ' + dateHour;
    },
    save() {
      this.errorOccurred = false;
      if (this.doesErrorExist()) {
        this.errorMessage = 'Neispravan unos podataka';
        this.errorOccurred = true;
        return;
      }
      if (this.payoutName.length > 250) {
        this.errorMessage = 'Naziv isplate može imati najviše 250 karaktera';
        this.errorOccurred = true;
        return;
      }
      this.loading = true;

      let payoutAmount = parseFloat(
        parseFloat(this.payoutAmount.replace(/,/g, '')).toFixed(2)
      );

      if (payoutAmount < 0) {
        payoutAmount = payoutAmount * -1;
      }

      let issueDate = this.issueDate.substring(0, this.issueDate.indexOf('Z'));
      issueDate = issueDate.split('T');

      financesInstance
        .post(
          `/communities/${
            this.$store.getters.getActiveCommunity.community_id
          }/transactions`,
          [
            {
              description: this.payoutName,
              amount: -payoutAmount,
              timestamp: `${issueDate[0]} ${issueDate[1]}`
            }
          ]
        )
        .then(async () => {
          await this.getTableData({
            communityId: this.$store.getters.getActiveCommunity.id,
            tableName: 'transactions'
          });
          if (this.$router.history.current.name !== 'communityFinancesHome') {
            this.setTableData(this.transactions.data);
          } else {
            this.getAccountDetails();
          }
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loading = false;
          this.showFailModal();
        });
    },
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      } else if (e.key === 'Enter') {
        this.save();
      }
    },
    doesErrorExist() {
      return (
        this.areFieldsEmpty() ||
        this.numberFieldContainsLetters() ||
        this.numberFieldZero()
      );
    },
    areFieldsEmpty() {
      return this.payoutName === '' || this.payoutAmount === '';
    },
    numberFieldContainsLetters() {
      return this.payoutAmount.match(/[a-zA-Z]/g) == true;
    },
    numberFieldZero() {
      return this.payoutAmount == 0;
    }
  },
  destroyed() {
    document.removeEventListener('keydown', this.processKeyboardEvent);
  }
};
</script>

<style lang="scss">
.body {
  padding: 2rem 0;
}

hr {
  margin-top: 0;
}

.input-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  position: relative;
}

.name--mod {
  width: 60%;
}

.input-span {
  position: absolute;
  font-size: 1.5rem;
  color: rgb(95, 95, 95);
  top: 0.5rem;
  pointer-events: none;
  transition: 0.2s all;
}
.transactoin-income-body {
  .datetime-mask {
    position: relative;

    .calendar--mod {
      position: absolute;
      right: 10px;
      bottom: 12px;
      color: #989899;
    }
  }

  .desc {
    margin-top: 1rem;
    font-size: 18px;
    color: rgb(95, 95, 95);
    margin-bottom: 0;
  }

  .datetime-mask:hover {
    cursor: text;
  }

  .vdatetime-input {
    opacity: 0;
    position: absolute;
  }

  .input-span--name {
    left: 1rem;
  }

  .input-span--amount {
    left: 1rem;
  }
}

input[type='number'] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input {
  margin-right: 15px;
}

.input--name:focus ~ .input-span--name,
.input--name:not(:placeholder-shown) ~ .input-span--name {
  transform: scale(0.75) translateY(-50px) translateX(-30px);
  // opacity: 0;
}

.input--amount:focus ~ .input-span--amount,
.input--amount:not(:placeholder-shown) ~ .input-span--amount {
  transform: scale(0.75) translateY(-50px) translateX(-30px);
}

.relative {
  position: relative;
}

.amount--mod {
  width: 30%;
}

.error {
  color: red;
  float: left;
  margin: 0 auto;
  margin-left: 1rem;
  display: flex;
  align-items: center;
}

.footer {
  width: 100%;
  .buttons {
    .btn--mod {
      height: 35px;
      min-width: 75px;
      margin-left: 5px;
      align-self: center;
    }

    button:disabled {
      background-color: var(--primary-color-lighten);
    }
  }
}

.buttons {
  float: right;
}
</style>
